import { DotsInputText, IDotsInputTextProps } from "dots-ui/dotsInputText";
import { useMemo } from "react";
import { getValueTooltip } from "../../../../utils";

export function AvisInputText<T = object>(
  props: Readonly<IDotsInputTextProps<T>>,
) {
  const { title, ...restProps } = props;

  const tooltipValue = useMemo(() => {
    return getValueTooltip(title, props.bag, props.bagField);
  }, [props.bag, props.bagField, title]);

  return (
    <DotsInputText<T> spacing="small" title={tooltipValue} {...restProps} />
  );
}
